export default __webpack_public_path__ + "static/media/brand-logo.de8cd973.svg";